module.exports = __webpack_public_path__ + "static/30-day-burst-tablet-grey-184f87eb0d7be1370746a5e994a91f3d.png";